import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Clock, Lightbulb } from "lucide-react";
import { api } from "@/lib/api";

export default function Guides() {
  const [guides, setGuides] = useState([]);

  useEffect(() => { api.get("/guides").then((r) => setGuides(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="guides-page">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-secondary mb-2">Guide passo-passo</div>
        <h1 className="font-heading font-bold text-4xl tracking-tighter">Pratiche italiane, spiegate umanamente.</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {guides.map((g, i) => (
          <Card key={g.id} className="p-6 rounded-2xl border fade-in-up" style={{ animationDelay: `${i * 0.05}s` }} data-testid={`guide-card-${g.id}`}>
            <div className="flex items-start justify-between mb-3 gap-3">
              <div>
                <Badge variant="secondary" className="rounded-full mb-2">{g.category}</Badge>
                <h3 className="font-heading font-semibold text-xl">{g.title}</h3>
              </div>
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground mb-4">
              <Clock className="w-3.5 h-3.5" /> {g.estimated_time}
            </div>
            <Accordion type="single" collapsible>
              <AccordionItem value="steps" className="border-b-0">
                <AccordionTrigger className="text-sm font-semibold" data-testid={`guide-toggle-${g.id}`}>Vedi i passi</AccordionTrigger>
                <AccordionContent>
                  <ol className="space-y-2 list-decimal list-inside text-sm text-muted-foreground">
                    {g.steps.map((s, k) => <li key={k} className="pl-1">{s}</li>)}
                  </ol>
                  {g.tip && (
                    <div className="mt-4 p-3 rounded-xl bg-accent/60 border border-border/60 flex gap-2 text-sm">
                      <Lightbulb className="w-4 h-4 text-secondary flex-shrink-0 mt-0.5" />
                      <span>{g.tip}</span>
                    </div>
                  )}
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </Card>
        ))}
      </div>
    </div>
  );
}
